import type { GraphQLSupporterContact } from '@sola/schema/dotcom/supporters/schema.generated.ts';

export const MOCK_SUPPORTER_CONTACTS: GraphQLSupporterContact[] = [
  {
    id: '0033b00002h7i46B1B',
    firstName: 'Walter',
    lastName: 'Salazar',
    preferredName: 'Walter',
    email: 'walter.salazar@gmail.com.invalid',
    phone: '(719) 555-3434',
    isPrimary: true,
    canVolunteer: true,
    preferences: {
      doNotCall: false,
      doNotContact: false,
      doNotEmail: false,
      doNotMail: false,
      doNotText: false,
      undeliverableEmail: false,
      undeliverablePhone: false,
      emailInterestCategories: [
        'Account_Transaction',
        'Sponsored_Child_Communication',
        'Your_Impact',
        'Compassion_Communication',
        'Help_Us_Improve',
      ],
      textInterestCategories: [
        'Account_Transaction',
        'Sponsored_Child_Communication',
        'Your_Impact',
      ],
      mailInterestCategories: [],
      phoneInterestCategories: [],
      subscriptionLists: [],
      lastLoginDate: null,
    },
  },
  {
    id: '0033b00002h7i46BBB',
    firstName: 'Sarah',
    lastName: 'Fergison',
    preferredName: 'Sarah',
    email: 'sarah.fergison@gmail.com.invalid',
    phone: '(719) 555-3434',
    isPrimary: false,
    canVolunteer: true,
    preferences: {
      doNotCall: false,
      doNotContact: false,
      doNotEmail: false,
      doNotMail: false,
      doNotText: true,
      undeliverableEmail: false,
      undeliverablePhone: false,
      emailInterestCategories: [
        'Account_Transaction',
        'Sponsored_Child_Communication',
        'Compassion_Prayer_Network',
        'Compassion_Explorer_Magazine_for_Kids',
      ],
      textInterestCategories: ['Volunteering_and_Visits'],
      mailInterestCategories: [],
      phoneInterestCategories: [],
      subscriptionLists: [],
      lastLoginDate: null,
    },
  },
  {
    id: '0033b00002h7i46BB1',
    firstName: 'Daniel',
    lastName: 'Wilson',
    preferredName: 'Daniel',
    email: 'daniel.wilson@gmail.com.invalid',
    phone: '(719) 555-3424',
    isPrimary: false,
    canVolunteer: true,
    preferences: {
      doNotCall: false,
      doNotContact: false,
      doNotEmail: true,
      doNotMail: false,
      doNotText: false,
      undeliverableEmail: false,
      undeliverablePhone: false,
      emailInterestCategories: [],
      textInterestCategories: [],
      mailInterestCategories: [],
      phoneInterestCategories: [],
      subscriptionLists: [],
      lastLoginDate: null,
    },
  },
  {
    id: '0033b00002h7i46BB2',
    firstName: 'Maya',
    lastName: 'Anderson',
    preferredName: 'Maya',
    email: 'maya.anderson@gmail.com.invalid',
    phone: '(719) 555-7621',
    isPrimary: false,
    canVolunteer: true,
    preferences: {
      doNotCall: false,
      doNotContact: false,
      doNotEmail: false,
      doNotMail: false,
      doNotText: false,
      undeliverableEmail: false,
      undeliverablePhone: false,
      emailInterestCategories: [],
      textInterestCategories: [],
      mailInterestCategories: [],
      phoneInterestCategories: [],
      subscriptionLists: [],
      lastLoginDate: null,
    },
  },
  {
    id: '0033b00002h7i46BB3',
    firstName: 'Henry',
    lastName: 'Carter',
    preferredName: 'Henry',
    email: 'henry.carter@gmail.com.invalid',
    phone: '(719) 555-8642',
    isPrimary: false,
    canVolunteer: true,
    preferences: {
      doNotCall: false,
      doNotContact: true,
      doNotEmail: false,
      doNotMail: false,
      doNotText: false,
      undeliverableEmail: false,
      undeliverablePhone: false,
      emailInterestCategories: [],
      textInterestCategories: [],
      mailInterestCategories: [],
      phoneInterestCategories: [],
      subscriptionLists: [],
      lastLoginDate: null,
    },
  },
  {
    id: '0033b00002h7i46BB2',
    firstName: 'NonVolunteer',
    lastName: 'Guest',
    preferredName: 'Non Volunteer',
    email: 'non.volunteer@gmail.com.invalid',
    phone: '(719) 555-7621',
    isPrimary: false,
    canVolunteer: false,
    preferences: {
      doNotCall: false,
      doNotContact: false,
      doNotEmail: false,
      doNotMail: false,
      doNotText: false,
      undeliverableEmail: false,
      undeliverablePhone: false,
      emailInterestCategories: [],
      textInterestCategories: [],
      mailInterestCategories: [],
      phoneInterestCategories: [],
      subscriptionLists: [],
      lastLoginDate: null,
    },
  },
];
